import React from 'react';
import ModelTop from '../../components/ModelTop';

export default function SearchWeb() {
  return (
    <ModelTop
      title={'Search'}
      src={'/video/website/search.mp4'}
      para1={
        "Users can click on 'condition' to add more information. This can make their search results more precise."
      }
    ></ModelTop>
  );
}
